{
  "title": "Autoriser l'accès à votre localisation ?",
  "body": "En autorisant l'accès à votre localisation, nous pouvons nous assurer que vous êtes bien arrivé à l'établissement pour l'enregistrement",
  "disagree": "Refuser",
  "agree": "Accepter"
}
